import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { WAREHOUSES } from '@app/constants';
import { useNewUserAccessRights, useWindowSize } from '@app/hooks';

import type { FC } from 'react';

import '@pages/Warehouses/WarehouseRegistry/ui/WarehousesRegistryHeader.tsx';

export const WarehousesRegistryHeader: FC = () => {
  const {
    userAccessRights: {
      Warehouse: { IsWarehouseCreate },
    },
  } = useNewUserAccessRights();

  const { isMobile } = useWindowSize();

  if (!IsWarehouseCreate) {
    return null;
  }

  return (
    <Link to={`/${WAREHOUSES}/add`} className="WarehousesRegistryHeader">
      <Button
        type="primary"
        icon={<PlusOutlined />}
        className={classNames('WarehousesRegistryHeader__button', {
          'full-width': isMobile,
        })}
      >
        Создать склад
      </Button>
    </Link>
  );
};
